import type { FunctionComponent, ReactElement } from 'react';

import type { ButtonProps } from '../controls/button/Button';

export interface IToast {
  button?: Pick<ButtonProps, 'onClick' | 'tk' | 'className'>;
  icon?: ReactElement;
  message: string;
  msgDynamicValues?: string[];
  toasterType?: ToastType;
}

export interface ToastProps extends IToast {
  duration?: number;
  onClose: () => void;
}

export interface ToastConnectedProps extends IToast {
  timeStamp: number;
}

export enum ToastType {
  AUTOPLAY_CONTINUED_NO_CHANGES = 'AUTOPLAY_CONTINUED_NO_CHANGES',
  MAX_PAYOUT_REACHED = 'MAX_PAYOUT_REACHED',
  TABLE_WILL_CLOSE = 'TABLE_WILL_CLOSE',
  TOAST_GAME_CANCELLED = 'TOAST_GAME_CANCELLED',
  TOAST_SUBTITLES_OFF = 'TOAST_SUBTITLES_OFF',
  TOAST_SUBTITLES_GO_TO_SETTINGS = 'TOAST_SUBTITLES_GO_TO_SETTINGS',
  TOAST_BET_ABOVE_MINIMUM = 'TOAST_BET_ABOVE_MINIMUM',
  TOAST_AUTOMATED_MESSAGE = 'TOAST_AUTOMATED_MESSAGE',
}

export type ToastConfig<P extends ToastConnectedProps = ToastConnectedProps> = {
  [key: string]: FunctionComponent<P>;
};
